



























import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import { TournamentTeamState } from '@/api/tournamentTeam'

@Component
export default class TournamentRegistrationClosedDialog extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)

  get isVisible() {
    return (
      this.tournamentModule.tournamentRegistrationClosedDialogVisible &&
      (!this.tournamentModule.selectedTournamentTeam ||
        this.tournamentModule.selectedTournamentTeam.state !==
          TournamentTeamState.Registered)
    )
  }

  get tournament() {
    return this.tournamentModule.selectedTournament
  }

  get isAutomated() {
    return (
      this.tournamentModule.selectedTournament &&
      this.tournamentModule.selectedTournament.isAutomated
    )
  }

  close() {
    if (this.tournament && this.tournament.isAutomated) {
      setTimeout(() => {
        this.$router.push({
          name: 'InstantMatchCatalog'
        })
      }, 500)
    }

    this.tournamentModule.setTournamentRegistrationClosedDialogVisible(false)
  }
}
